import config from '@/common/config';

const FORMS_MESSAGE_SOURCE = 'yhrs-forms';
const FORMS_MESSAGE_VERSION = 1;
const PARENT_MESSAGE_SOURCE = 'yhrs-parent';
const PARENT_MESSAGE_VERSION = 1;

function trimTrailingSlash(value) {
	return (value || '').replace(/\/+$/, '');
}

export function getFormsAppBaseUrl() {
	return trimTrailingSlash(config.FORMS_APP_URL || 'http://localhost:3001');
}

export function getFormsAppOrigin() {
	return new URL(getFormsAppBaseUrl()).origin;
}

export function buildEmbeddedFormsUrl(path, query = {}) {
	const normalizedPath = path ? (path.startsWith('/') ? path : `/${path}`) : '/';
	const url = new URL(`${getFormsAppBaseUrl()}${normalizedPath}`);
	const parentOrigin = window.location.origin;
	const params = {
		embedded: 'true',
		embedStyle: 'card',
		parentOrigin,
		...query
	};

	Object.keys(params).forEach(key => {
		if (params[key] === undefined || params[key] === null || params[key] === '') return;
		url.searchParams.set(key, params[key]);
	});

	return url.toString();
}

export function isTrustedFormsMessage(event, expectedOrigin = getFormsAppOrigin()) {
	if (!event || event.origin !== expectedOrigin) return false;
	const data = event.data;
	return !!data && data.source === FORMS_MESSAGE_SOURCE && data.version === FORMS_MESSAGE_VERSION;
}

function getClaimValue(claims, keys = []) {
	for (const key of keys) {
		const value = claims[key];
		if (value !== undefined && value !== null && value !== '') {
			return value;
		}
	}

	return null;
}

function getLoginHintFromClaims(claims) {
	const directValue = getClaimValue(claims, ['login_hint', 'email', 'preferred_username', 'upn']);
	if (directValue) return directValue;

	if (Array.isArray(claims.emails) && claims.emails.length > 0 && claims.emails[0]) {
		return claims.emails[0];
	}

	const signInNames = claims.signInNames || claims.signInNamesInfo;

	if (Array.isArray(signInNames)) {
		const emailSignIn = signInNames.find(item => item && (item.type === 'emailAddress' || item.type === 'email'));
		if (emailSignIn && emailSignIn.value) {
			return emailSignIn.value;
		}
	}

	return null;
}

export function resolveMsalAccount(preferredAccount, msalInstance) {
	if (preferredAccount) return preferredAccount;
	if (!msalInstance) return null;

	const activeAccount = typeof msalInstance.getActiveAccount === 'function' ? msalInstance.getActiveAccount() : null;
	if (activeAccount) return activeAccount;

	if (typeof msalInstance.getAllAccounts === 'function') {
		const accounts = msalInstance.getAllAccounts();
		if (Array.isArray(accounts) && accounts.length > 0) {
			return accounts[0];
		}
	}

	return null;
}

export function buildFormsAuthContext(account) {
	if (!account) return {};

	const claims = account.idTokenClaims || {};
	const loginHint =
		account.username ||
		getLoginHintFromClaims(claims) ||
		null;

	const sid = claims.sid || null;

	const authContext = {};

	if (loginHint) {
		authContext.loginHint = loginHint;
	}

	if (sid) {
		authContext.sid = sid;
	}

	return authContext;
}

export function postMessageToFormsIframe(iframe, type, payload, targetOrigin = getFormsAppOrigin()) {
	if (!iframe || !iframe.contentWindow || !type) return false;

	iframe.contentWindow.postMessage(
		{
			source: PARENT_MESSAGE_SOURCE,
			version: PARENT_MESSAGE_VERSION,
			type,
			payload
		},
		targetOrigin
	);

	return true;
}

export { FORMS_MESSAGE_SOURCE, FORMS_MESSAGE_VERSION, PARENT_MESSAGE_SOURCE, PARENT_MESSAGE_VERSION };
